export default __webpack_public_path__ + "static/media/portfolio1.5949c86d.png";